import DropdownForm from '@App/kit/fields/v2/DropdownForm'
import InputTextForm from '@App/kit/fields/v2/InputTextForm'
import React, { PropsWithChildren } from 'react'
import CheckboxForm from '@App/kit/fields/v2/CheckboxForm'
import { FormFieldTypes } from '@App/enum/form-field-types'
import FormFieldProps, { FormFieldType, isFormFieldProp } from '@App/forms/v2/common/form-field'
import DatePickerForm from '@App/kit/fields/v2/DatePickerForm'
import DropdownFormFieldProps from '@App/forms/v2/common/dropdown-form-field'
import CheckboxFormFieldProps from '@App/forms/v2/common/checkbox-form-field'
import DatePickerFormFieldProps from '@App/forms/v2/common/date-picker-form-field'
import MultiDropdownForm from '@Fields/MultiDropdownForm'
import InputTextAreaForm from '@Fields/v2/InputTextAreaForm'
import InternationalPhoneInput, { InternationalPhoneInputProps } from '@Fields/v2/InternationalPhoneInput'

interface FormFieldFromPropsProps {
    field: FormFieldType<unknown> | undefined
    isDisabled?: boolean
    validationDependency?: FormFieldProps[]
}

const FormFieldFromProps = ({
    field,
    isDisabled,
    validationDependency,
    children,
}: PropsWithChildren<FormFieldFromPropsProps>) => {
    const getFormFieldComponent = (): React.ReactNode => {
        if (!field || !isFormFieldProp(field)) {
            throw new Error('Unable to Render!')
        }

        switch (field.type) {
            case FormFieldTypes.DROPDOWN:
                return (
                    <DropdownForm {...(field as DropdownFormFieldProps)} validationDependency={validationDependency} />
                )
            case FormFieldTypes.CHECKBOX:
                return <CheckboxForm {...(field as CheckboxFormFieldProps)}>{children}</CheckboxForm>
            case FormFieldTypes.TEXT:
                return <InputTextForm {...field} isDisabled={isDisabled} validationDependency={validationDependency} />
            case FormFieldTypes.TEXTAREA:
                return (
                    <InputTextAreaForm {...field} isDisabled={isDisabled} validationDependency={validationDependency} />
                )
            case FormFieldTypes.DATEPICKER:
                return <DatePickerForm {...(field as DatePickerFormFieldProps)} />
            case FormFieldTypes.MULTI_DROPDOWN:
                return <MultiDropdownForm {...(field as DropdownFormFieldProps)} />
            case FormFieldTypes.INTERNATIONAL_PHONE:
                return <InternationalPhoneInput {...(field as InternationalPhoneInputProps)} />
            case FormFieldTypes.CHECKBOX_GROUP:
                throw new Error('Checkbox Groups are not currently supported in v2 forms.')
            case FormFieldTypes.RADIO:
                throw new Error('Radio Buttons are not currently supported in v2 forms.')
            case FormFieldTypes.AUTOCOMPLETE:
                throw new Error('Not yet implemented autocomplete')
            default:
                throw new Error(`Unsupported form field type: ${field.type}`)
        }
    }

    const formFieldProps = field && isFormFieldProp(field) ? field : undefined

    if (formFieldProps?.inputHeader) {
        return (
            <>
                {formFieldProps.inputHeader}
                {getFormFieldComponent()}
            </>
        )
    } else {
        return getFormFieldComponent()
    }
}

export default FormFieldFromProps
